import { DeviceBuildModel, CreateProjectResponse, CreateProjectOptions } from '@bymason/controller-api-hooks';
import { valSchema, valString } from '@bymason-private/legacy-pattern-components';

export type FormData = CreateProjectOptions;
export type FormFields = keyof FormData;

export interface CreateProjectModalProps {
  open: boolean;
  controllerBuildEnabled?: boolean;
  onClose: () => void;
  onSuccess?: (newProject: CreateProjectResponse) => void;
  onError?: (message: string, code?: number) => void;
  deviceList: DeviceBuildModel[];
  existingProjectNames?: string[];
}

export enum Fields {
  Name = 'name',
  Description = 'description',
  DeviceFamily = 'deviceFamily',
  ApiLevel = 'apiLevel',
}

const REQUIRED_MSG = 'Required';
const MAX_PROJECT_NAME_LENGTH = 256;
const MAX_PROJECT_DESCRIPTION_LENGTH = 1024;

export const schema = valSchema().shape({
  [Fields.Name]: valString()
    .alphanumericOnly()
    .required(REQUIRED_MSG)
    .max(
      MAX_PROJECT_NAME_LENGTH,
      `Project name length must be ${MAX_PROJECT_NAME_LENGTH} characters or less`
    ),
  [Fields.Description]: valString().max(
    MAX_PROJECT_DESCRIPTION_LENGTH,
    `Project description length must be ${MAX_PROJECT_DESCRIPTION_LENGTH} characters or less`
  ),
  [Fields.DeviceFamily]: valString().required(REQUIRED_MSG),
  [Fields.ApiLevel]: valString().required(REQUIRED_MSG),
});

export const initialValues = {
  [Fields.Name]: '',
  [Fields.Description]: '',
  [Fields.DeviceFamily]: '',
  [Fields.ApiLevel]: undefined,
};
